import { combineReducers } from 'redux';
import UserProfileReducer from './user/reducers';
import ApplicationReducer from './application/reducers';
import ServerReducer from './server/reducers';

const ApiReducers = combineReducers({
    profile: UserProfileReducer,
    applications: ApplicationReducer,
    servers: ServerReducer
});

export default ApiReducers;
